<template>
    <b-modal id="modal-patient-list" ref="modal-patient-list" :title="title" @cancel="resetFormData" size="xl">
        <div v-if="items?.data?.length">
            <b-row class="mb-3">
                <b-col md="12">
                    <b-list-group>
                        <b-list-group-item class="patient-item" id="my-table" v-for="(d, i) in items?.data" :key="`searched-patient-${i}`"  @click="bookAppointment(d)">
                            <b-media class="mb-4">
                            <template v-slot:aside>
                                <div class="user-profile text-center">
                                <b-img :src="getImageUri(d?.avatar)" :alt="`Patient-${d?.patient_no}`" fluid title="View Picture" class="profile-pic"></b-img>
                                </div>
                            </template>
                            <b-media-body>
                                <table class="table table-sm" >
                                <thead>
                                    <tr>
                                    <th colspan="4">
                                        {{ "( "+ d?.patient_no +" ) " + d?.first_name + " " + (d?.middle_name ?? '') + " " + d?.last_name }}
                                    </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                    <td><strong>Age:</strong> {{ computeAge(d?.birth_date) }}</td>
                                    <td><strong>Birth Date:</strong> {{ d?.bday }}</td>
                                    <td><strong>Sex:</strong> {{ d?.sex }}</td>
                                    <td><div v-if="userDetails?.role != 'DA'"><strong>Contact No.:</strong> {{ d?.contact_no }}</div></td>
                                    </tr>
                                    <tr>
                                    <td><strong>Civil Status:</strong> {{ d?.civil_status }}</td>
                                    <td><strong>Nationality:</strong> {{ d?.nationality }}</td>
                                    <td><strong>Occupation:</strong> {{ d?.occupation }}</td>
                                    <td><strong>Has serious illness:</strong> {{ d?.has_serious_illness === 'Y' ? 'Yes' : 'No' }}</td>
                                    </tr>
                                </tbody>
                                </table>
                            </b-media-body>
                            </b-media>
                        </b-list-group-item>
                    </b-list-group>
                </b-col>
            </b-row>
            <b-row class="mb-3">
                <b-col md="12">
                    <b-pagination
                    class="float-right"
                    v-model="currentPage"
                    prev-text="Previous"
                    next-text="Next"
                    first-text="First"
                    last-text="Last"
                    :total-rows="items?.total"
                    :per-page="items?.per_page"
                    aria-controls="my-table"
                    ></b-pagination>
                </b-col>
            </b-row>
        </div>
        <template v-slot:modal-footer>
            <b-button variant="primary" @click="bookAppointmentNonExistingPatient(patientDetails)">Book Non-existing Patient</b-button>
            <b-button variant="secondary" @click="$bvModal.hide('modal-patient-list')">Close</b-button>
        </template>
    </b-modal>
</template>
<script>

import patient from '../../../../services/patient'
import _ from 'lodash'
import { mapGetters } from 'vuex'

export default {
    name: 'CalendarPatientListComponent',
    props: {
        patientDetails: Object
    },
    mounted () {
        if (this.patientDetails) {
                this.getSearchResults()
            }
    },
    created () {
        this.debouncedGetSearchResults = _.debounce(() => {
            this.getSearchResults(this.currentPage)
        }, 500)
    },
    watch: {
        userActiveBranch () {
            this.debouncedGetSearchResults()
        },
        currentPage () {
            this.debouncedGetSearchResults()
        },
        patientDetails: {
            handler (newVal) {
                if (newVal) this.getSearchResults()
            },
            immediate: true
        }
    },
    data () {
        return {
            title: 'Select Patient',
            isLoading: false,
            items: {},
            currentPage: 1
        }
    },
    computed: {
        ...mapGetters({
            userActiveBranch: 'Auth/userActiveBranch'
        })
    },
    methods: {
        getSearchResults (page = 1) {
            this.isLoading = true
            this.items = {}
            const data = {
                patient_no: this.patientDetails.patientNo,
                first_name: this.patientDetails.firstName,
                last_name: this.patientDetails.lastName,
                birth_date: this.patientDetails.birthDate,
                contact_no: this.patientDetails.contactNumber,
                branchId: this.userActiveBranch?.id
            }
            patient.searchPatientsForCalendar(data, page)
            .then(({ data }) => {
                if (data?.success) {
                this.items = data?.data
                } else {
                confirm('Oops, something went wrong. Please contact the system in charge.')
                }
                this.isLoading = false
            })
        },
        resetFormData () {
        },
        computeAge (bday) {
            const today = new Date()
            const birthDate = new Date(bday)
            let age = today.getFullYear() - birthDate.getFullYear()
            let m = today.getMonth() - birthDate.getMonth()
            if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age--
            }
            return age
        },
        getImageUri (uri) {
            if (uri) {
                var cnt = uri.split('/')
                if (cnt.length > 3) {
                    return uri
                } else {
                    return process.env.VUE_APP_API_BASE_URL + uri
                }
            }
            return require('../../../../assets/images/page-img/21.jpg')
        },
        bookAppointment (patientData) {
            this.$bvModal.hide('modal-patient-list')
            this.$emit('selectPatient', patientData)
        },
        bookAppointmentNonExistingPatient (patientData) {
            this.$bvModal.hide('modal-patient-list')
            this.$emit('selectNonExistingPatient', patientData)
        }
    }
}
</script>
<style scoped>
    .patient-item {
        cursor: pointer; /* show hand cursor */
        transition: background-color 0.2s ease, transform 0.1s ease;
    }

    .patient-item:hover {
        background-color: #f5f7fa; /* light gray or your preferred hover color */
        transform: scale(1.1); /* optional: slight zoom effect */
    }
</style>
